import { Link } from 'react-router-dom'
import Header from '../Header'
import Footer from '../Footer'
import Slider from '../Slider'
import logo from '../../assets/images/logo.png';
import jpea from '../../assets/images/jpea.png';
import gofar from '../../assets/images/gofar.png';



import './home.sass'

const Home = () => {
  

   
    return (

        <main className='home'>
            <Header />
            <Slider />                
            <div className='container container--narrow'>
                <section className='announcement announcement__alt'>
                     <div className='layout layout--narrow'>
                        <div className='layout__col layout__col--3'>
                            <h2 className='announcement__title'><small className='letterspacing'>ANNOUNCING:</small> <br />The Public Service Academy</h2>
                            <p>The Public Service Academy is composed of four half-day workshops. Its mission is to help employees at all levels foster professionalism and excellence in their organizations, and in the services they provide to the public and their com</p>
                            
                            <Link to='/public-workshops' className='btn btn--alt'title='Learn more about public workshops'>Learn More
                            </Link>
                        </div>
                        <div className='layout__col layout__col--7'>
                            <strong><small>Upcoming Academy Workshop Dates: *Indicates afternoon workshop</small></strong>
                            <h4 className='announcement__title announcement__title--sub'>Managing Your Time, Priorities, Work &amp; Life Balance</h4>
                            October 21, 23, 29*, 2025 <small>(Registration Now OPEN)</small>
                            <h4 className='announcement__title announcement__title--sub'>Dealing Successfully With Customers: <i>Staying Courteous Under Pressure</i></h4>
                            November 18, 20, December 3* &amp; 5, 2025 <small>(Registration opens October 16, 2025)</small>
                            <h4 className='announcement__title announcement__title--sub'>Being an Effective Team Player: <i>Working Together - What to Do</i> <br /><small>-Includes Special Section on Resolving Conflict on the Job</small></h4>
                            January 20, 22, 28*, 2026 <small>(Registration opens December 22, 2025)</small>
                        </div>
                    </div>
                </section>
            </div>
            <section className='services'>
                <div className='container'>
                    <div className='services__container'>
                        <Link to='/contact' className="services__item services__item--assessments" title="Learn more about comprehensive service assessment">
                            <div className="services__content">
                                <h3 className="services__title">Assessment</h3>
                                <p>We use surveys, interviews, and observation to conduct a comprehensive service assessment.</p>
                            </div>
                        </Link>
                        <Link to='/about-us' className="services__item services__item--restructuring" title="Learn more about Public Service Excellence">
                            <div className="services__content">
                                <h3 className="services__title">Planning</h3>
                                <p>We identify training, and processes to take your team to the next level. </p>
                            </div>
                        </Link>
                        <Link to='/public-workshops' className="services__item services__item--interim" title="Learn more about workshops services">
                            <div className="services__content">
                                <h3 className="services__title">Workshops</h3>
                                <p>We design workshops to address issues specific to your organization and the public sector.  </p>
                            </div>
                        </Link>
                        <Link to='/contact' className="services__item services__item--performance" title="Learn more about personalized support for leaders within the public sector">
                            <div className="services__content">
                                <h3 className="services__title">Coaching</h3>
                                <p>We provide personalized support for leaders within the public sector. </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </section>
          
            <section className='main'>
                    <div className='container'>
                                <img src={logo} alt="PUBLIC SECTOR EXCELLENCE" className='img__inline' />
                                <p className='text__inline'>A training and development partnership that specializes in helping Public Sector leaders, managers, supervisors and employees build excellence in their organizations and in the services that they provide.</p>

                        <div className='grid grid--col2 grid--centered grid--space'>
                            <div className='grid__col'>
                                <a href='https://jpea.com/' target="_blank" rel="noreferrer">
                                    <img src={jpea} alt="JPEA" className='grid__img' />
                                </a>
                                <p>Visit the JPEA website to learn more about JPEA assessment.</p>
                            </div>
                            <div className='grid__col'>
                                <a href='https://thegofarcenter.com/' target="_blank" rel="noreferrer">
                                    <img src={gofar} alt="Go Far" className='grid__img' />
                                </a>
                                <p>Visit the GoFar website to learn more about GoFar assessment.</p>
                            </div>
                        </div>

                    </div>
            </section>
            <Footer />
        </main>

    )
}

export default Home